interface Props {
  children: React.ReactNode
  className?: string
  colSpan?: number
}

const Cell = ({ children, className = "", colSpan }: Props) => {
  return (
    <td
      {...(colSpan ? { colSpan } : {})}
      className={`px-2 md:px-4 py-3 md:py-6 ${className}`}
    >
      {children}
    </td>
  )
}

export default Cell
